jQuery(function ($) {
	$(".mobile-search-button").on("click", function() {

		//Si el menu esta visible, ocultarlo
		if( $("#navbar").hasClass("show") ) {
			$("#navbar").removeClass("show")
		}

		$("#mobile-search-form").toggle('slow');
	})


	$("#select_category_format").on("change", function() {
		window.location.href = $(this).val();
		console.log($(this).val())
	})

});